import { useEffect, useRef, useState } from 'react';
import { ToastManager } from '../utils/ToastManager';
/**
 * Custom hook to handle toast stacking
 * Returns the vertical offset that should be applied to position this toast
 */
export function useToastStacking() {
    const [offsetY, setOffsetY] = useState(0);
    const toastIdRef = useRef(`toast-${Date.now()}-${Math.random()}`);
    const containerRef = useRef(null);
    const observerRef = useRef(null);
    useEffect(() => {
        const toastId = toastIdRef.current;
        // Register with ToastManager
        ToastManager.register({
            id: toastId,
            height: 0,
            onPositionUpdate: (newOffsetY) => {
                setOffsetY(newOffsetY);
            },
        });
        // Set up ResizeObserver to track toast height changes
        if (containerRef.current) {
            observerRef.current = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    // Add extra padding to account for borders, shadows, and visual effects
                    const height = entry.contentRect.height + 8;
                    ToastManager.updateHeight(toastId, height);
                }
            });
            observerRef.current.observe(containerRef.current);
            // Initial height update
            const initialHeight = containerRef.current.getBoundingClientRect().height;
            if (initialHeight > 0) {
                ToastManager.updateHeight(toastId, initialHeight + 8);
            }
        }
        // Cleanup on unmount
        return () => {
            if (observerRef.current) {
                observerRef.current.disconnect();
            }
            ToastManager.unregister(toastId);
        };
    }, []);
    return { containerRef, offsetY };
}
